export const januaryUppercase = "u_KUzd";
export default {januaryUppercase};